import { useMutation } from "@tanstack/react-query";
import CommentsAPI from "../../api/CommentsAPI";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";

interface Props {
  context: string;
  contextID: string;
  addSubscriber?: boolean;
  onSuccess: () => void;
}

// For update the subscribers
export function useUpdateNotifications() {
  const updateNotifications = useMutation({
    mutationFn: ({ context, contextID, addSubscriber }: Props) =>
      CommentsAPI.updateNotifications(context, contextID, addSubscriber),
    onSuccess: (_, { onSuccess }) => {
      callFunctionIfExists(onSuccess);
    },
    onError: (err) => {
      console.log(getErrorMessage(err));
    },
  });

  return {
    updateNotifcations: updateNotifications.mutate,
    updatingNotifications: updateNotifications.isPending,
    error: updateNotifications.error,
  };
}
